import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { GoogleTable } from 'components/Tables/GoogleTable';
const Googles: FC = observer(() => {
  return <GoogleTable />;
});

export default Googles;
